<template lang="pug">
v-container(fluid data-test="results-page")
  portal(to='toolbar') 
    v-toolbar-title Results
  
  v-card
    filters(
      @filterChanged="loadList({})"
    )
    list(
      :list="list" 
      
      :pagination="pagination" 
      :primaryPagination="primaryPagination"
      :loading="loading" 
      :sortModel="sortModel"
      :sort-by.sync="sortModel.by"
      :sort-desc.sync="sortModel.desc"
      @update:sort-desc="updateSorting"
      @loadMore="loadList({more: true})"
      @paginationChange="loadList({})"
    )
  
  v-btn( 
    color="primary" fab @click="loadLogs" data-test="log-btn"
    v-show="log"
  ).btn-floating
    v-icon(color="white") mdi-post
  v-navigation-drawer(
    v-model="logShowing"
    fixed
    right
    width="400"
    ref='drawer'
    v-if="log"
  )
    logs(:value="logShowing" @click:loadMore="loadLogsMore" :model="log" ref="log")
      template(v-slot:candidateName="props")
        span.link  {{ props.candidate.name }}
        span.link  - {{ props.candidate.number }}, 
</template>

<script>
import {mapGetters} from "vuex"
import PaginationMixin from "@/mixins/pagination.mixin"

import Svc from "./core/results-service"
import errorsMixin from '@/mixins/errors.mixin'
import ResultsBroadcast from "./core/models/resultsExamBroadcast"
import { RESERVED_EXAM } from './core/models/resultModel'
import ResultReservedExam, { RESULT_STATUS, RESULT } from './core/models/resultReservedExam'
import ResultsLogModel from "./core/models/resultLogModel"
import { LOG_PAGE, CRM_PERMS, VIEWPORTS } from '@/util/const'
import PaginationModel from "@/models/paginationModel"
import permsMixin from '@/mixins/perms.mixin'
import ResultSortModel from "./core/models/resultSortModel"

export default {
  mixins: [PaginationMixin, errorsMixin, permsMixin],

  metaInfo: {
    meta: [
      { vmid: 'viewport-main', name: 'viewport', content: VIEWPORTS.DEFAULT }
    ]
  },

  data: () => ({
    svc: new Svc(),
    loading: false,
    list: [],
    examBroadcast: null,
    log: null,
    logShowing: false,
    primaryPagination: null,
    pagination: null,
    sortModel: {},
  }),

  inject: ['perms'],

  created() {
    this.checkPerm(CRM_PERMS.RESULTS)
    this.init()
  },

  mounted() {
  
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/current'
    }),
  },

  methods: {
    init() {
      this.initExamBroadcast()
      this.initSortModel(this.$route.query)
    },
    async initExamBroadcast() {
      let tokens
      tokens = await this.$auth.getTokensFromRepoOrRefresh()
      this.examBroadcast = new ResultsBroadcast(tokens.access)
      this.examBroadcast.startListen(this.examResultHandler)
    },

    async initLogs(wsURL) {
      let tokens = await this.$auth.getTokensFromRepoOrRefresh()
      this.log = new ResultsLogModel(
        {page: [LOG_PAGE.EXAM_RESULTS]}, 
        `${wsURL}?auth_token=${tokens.access}`
      )
      this.log.ws.addEventListener("message", this.listenLogs)
    },

    listenLogs(msg) {
      this.log.listen(msg)
    },

    examResultHandler(msg) { 
      let itemIndex = this.list.findIndex((item) => item.ID === msg[RESERVED_EXAM.ID])
      if(itemIndex < 0) return
      
      for(let field in msg) {
        if(field in this.list[itemIndex]) {
          if(field === 'result') 
            this.list[itemIndex].result = new ResultReservedExam(msg[RESERVED_EXAM.RESULT])
          else this.list[itemIndex][field] = msg[field]   
          
        }
        if(field === 'has_come_to_course') this.list[itemIndex].hasComeToCourse = msg[field]   
        
      }
      if(
        'result' in msg &&  (
          msg[RESERVED_EXAM.RESULT][RESULT.STATUS] === RESULT_STATUS.LOADED 
        || msg[RESERVED_EXAM.RESULT][RESULT.STATUS] === RESULT_STATUS.FAILED)
      ) 
        this.list[itemIndex].loading = false
    },

    async loadList({more = false}) {
      try {
        this.loading = true
        let {results, pagination} = await this.svc.list(this.$route.query)
        this.pagination = new PaginationModel(this.setPaginationParams(pagination))
        if(!more) {
          this.list = results
          this.setPrimaryPagination()
        } 
        else this.list.push(...results)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    loadLogs() {
      if(this.logShowing) {
        this.logShowing = false
        return
      }
      this.$refs.log.loadData({
        ...this.$refs.log.getDefaultPaginationParams(), 
        
      })
      this.logShowing = true
    },

    loadLogsMore() {
      this.$refs.log.loadMore({
        ...this.$refs.log.getPaginationParams(),
      })
    },

    setPrimaryPagination() {
      this.primaryPagination = {
        page: this.pagination.page,
        size: this.pagination.size
      }
    },

    initSortModel() {
      this.sortModel = new ResultSortModel(this.$route.query)
    },

    async updateSorting() {
      let data = this.sortModel.getApiData(this.$route.query)
      let ordering
      if(data.ordering.length) ordering = data.ordering
      await this.$router.replace({ query: { ...this.$route.query, ...this.getDefaultPagination(), ordering: ordering}})
      this.loadList({})
    },


  },

  watch: {
    currentUser: {
      handler: function(newUserData) {
        if(newUserData && newUserData.logsWebsocketPath) this.initLogs(newUserData.logsWebsocketPath)
      },
      immediate: true
    }
  },

  provide: function() {
    return {
      getDefaultPagination: this.getDefaultPagination,
      svc: this.svc
    }
  },


  beforeRouteLeave(to, from , next) {
    this.examBroadcast.close()
    if(this.log && this.log.ws) {
      this.log.ws.removeEventListener("message", this.listenLogs)
      this.log.ws.close()
    }
    
    next()
  },

  components: {
    filters: () => import('./components/ResultsFilters.vue'),
    list: () => import('./components/ResultsList.vue'),
    logs: () => import('@/app/admin/components/Log.vue'),
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/_placeholder.scss";
@import "@/assets/scss/_table_spread";
</style>
